module.exports = "<h2>People and businesses sending and receiving money</h2> <crud-clerk-tax-entity-curate></crud-clerk-tax-entity-curate> <h2>Tax Regions</h2> <crud-clerk-tax-region-curate></crud-clerk-tax-region-curate> <h2>Relations between people and businesses sending and receiving money</h2> <crud-clerk-tax-entity-relation-curate></crud-clerk-tax-entity-relation-curate> <h2>Relation types</h2> <crud-clerk-tax-entity-relation-type-curate></crud-clerk-tax-entity-relation-type-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/financial-events/inspect.financial-events.tax-entities.html
// module id = 4162
// module chunks = 86